import { api } from '@/lib/axios';
import type { Page } from '@/services/chantiers';

export type ChequeType = 'EMIS' | 'RECU';
export type ChequeStatut = 'EN_ATTENTE' | 'REMIS' | 'ENCAISSE' | 'REJETE' | 'ANNULE';

export const CHEQUE_TYPE_LABEL: Record<ChequeType, string> = { EMIS: 'Émis', RECU: 'Reçu' };
export const CHEQUE_STATUTS: ChequeStatut[] = ['EN_ATTENTE', 'REMIS', 'ENCAISSE', 'REJETE', 'ANNULE'];
export const CHEQUE_STATUT_LABEL: Record<ChequeStatut, string> = {
  EN_ATTENTE: 'En attente', REMIS: 'Remis en banque', ENCAISSE: 'Encaissé', REJETE: 'Rejeté', ANNULE: 'Annulé',
};

export interface ChequeDTO {
  id: string;
  numero: string;
  type: ChequeType;
  banque: string | null;
  compte_id: string | null;
  tiers_id: string | null;
  tiers_nom: string | null;
  beneficiaire_libre: string | null;
  chantier_id: string | null;
  montant: number;
  date_emission: string | null;
  date_echeance: string | null;
  date_encaissement: string | null;
  statut: ChequeStatut;
  objet: string | null;
  scan_url: string | null;
  notes: string | null;
  is_archived: boolean;
}

export interface ChequeInput {
  numero: string;
  type: ChequeType;
  banque?: string | null;
  compte_id?: string | null;
  tiers_id?: string | null;
  beneficiaire_libre?: string | null;
  chantier_id?: string | null;
  montant: number;
  date_emission?: string | null;
  date_echeance?: string | null;
  date_encaissement?: string | null;
  statut?: ChequeStatut;
  objet?: string | null;
  scan_url?: string | null;
  notes?: string | null;
}

export interface ChequeSynthese {
  emis_en_cours: number;
  recus_en_cours: number;
  emis_encaisses: number;
  recus_encaisses: number;
}

export async function listCheques(params?: { type?: ChequeType; statut?: ChequeStatut; q?: string; archives?: boolean; size?: number }): Promise<Page<ChequeDTO>> {
  const { data } = await api.get<Page<ChequeDTO>>('/cheques', { params });
  return data;
}
export async function getSyntheseCheques(): Promise<ChequeSynthese> {
  const { data } = await api.get<ChequeSynthese>('/cheques/synthese');
  return data;
}
export async function createCheque(payload: ChequeInput): Promise<ChequeDTO> {
  const { data } = await api.post<ChequeDTO>('/cheques', payload);
  return data;
}
export async function updateCheque(id: string, payload: Partial<ChequeInput> & { is_archived?: boolean }): Promise<ChequeDTO> {
  const { data } = await api.put<ChequeDTO>(`/cheques/${id}`, payload);
  return data;
}
export async function changerStatutCheque(id: string, statut: ChequeStatut): Promise<ChequeDTO> {
  const { data } = await api.post<ChequeDTO>(`/cheques/${id}/statut`, null, { params: { statut } });
  return data;
}
export async function deleteCheque(id: string): Promise<void> {
  await api.delete(`/cheques/${id}`);
}
